module.exports = __webpack_public_path__ + "img/375.72f69fa1.jpg";